import { inject, Injectable, isSignal } from '@angular/core';
import { MenuPoint } from '@agilox/ui-common';
import { Role } from '../enums/role.enum';
import { MENU_POINTS } from '../tokens/menu-points.token';
import { NavVariant } from '../enums/nav-variant.enum';
import { TranslateService } from '@ngx-translate/core';
import { MenuPointToken } from '../interfaces/menu-point-token.interface';

@Injectable()
export class MenuPointService {
	private menuPointsInput = inject(MENU_POINTS);
	protected translate: TranslateService = inject(TranslateService);

	private get menuPoints(): MenuPointToken {
		return isSignal(this.menuPointsInput) ? this.menuPointsInput() : this.menuPointsInput;
	}

	public getMenuPointsByCategory(type: NavVariant, role?: Role): MenuPoint[] {
		const clonedMenu = structuredClone(this.menuPoints[type.toLowerCase()]);
		return this.translateMenuPoints(this.filterByRole(clonedMenu, role) || []);
	}

	private filterByRole(menuPoints: MenuPoint[], role?: string): MenuPoint[] {
		return menuPoints
			?.filter(
				(menuPoint: MenuPoint) =>
					menuPoint.roles.length === 0 ||
					menuPoint.roles.some((menuPointRole: any) => menuPointRole === role)
			)
			.map((menuPoint: MenuPoint) => {
				if (menuPoint.submenus && menuPoint.submenus?.length > 0) {
					menuPoint.submenus = this.filterByRole(menuPoint.submenus, role);
				}
				return menuPoint;
			});
	}

	private translateMenuPoints(menuPoints: MenuPoint[]): MenuPoint[] {
		return menuPoints.map((menuPoint: MenuPoint) => {
			menuPoint.name = this.translate.instant(menuPoint.name);

			if (menuPoint.submenus && menuPoint.submenus.length > 0) {
				menuPoint.submenus = this.translateMenuPoints(menuPoint.submenus);
			}
			return menuPoint;
		});
	}
}
